module.exports = "/_next/static/images/create-account-banner-v2-9557dda0272898205437a56c30698f88.jpg";